/* eslint-disable */
import React,{useState} from 'react';
//css
import 'contents/assets/scss/page/mypage.scss';
//component
import Paging from '../../component/Inc/Paging';
import Tab from '../../component/Inc/Tab';
import Upload from '../../component/Inc/Upload';
import Calendar from '../../component/Inc/Calendar';
const sampleImg = 'https://via.placeholder.com/175x250'
//image
function SendPaystub() {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title:"미발송", cnt:"435", value:0},
    {title:"발송 완료", cnt:"5", value:1},
    {title:"미확인", cnt:"5", value:2},
    {title:"확인 완료", cnt:"5", value:3},
  ];
  return (
    <main className="com_container">
      <div className="com_center_wrap p_send_paystub">
        <section className="com_tit_wrap">
          <h2 className='com_pg_tit icon menu8_10'>급여 명세서 발송</h2>
        </section>
        <div className="com_pg_container">
          <section className="box full">
            <div className='com_board_list__top'>
              <div className="board_select">
                <select className="select">
                  <option value="이지수능 (본사)">이지수능 (본사)</option>
                </select>
                <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              </div>
              <article className='search end'>
                <input type="search" placeholder='검색할 내용을 입력해 주세요.' className="input s type_search" />
                <button className="com_btn gray ws s icon_search"></button>
              </article>
            </div>
            <hr className="com_divider"/>
            <div className='com_board_list__top has_chk_calendar'>
              <div className="check">
                <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                <label htmlFor="rdo01">교사 수업 명세서</label>
                <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                <label htmlFor="rdo02">인센티브 명세서</label>
              </div>
              <Calendar/>
            </div>
          </section>
          <section className="box sec_list">
            <table className="com_board_list">
              <colgroup>
              </colgroup>
              <thead>
                <tr>
                  <th>선택</th>
                  <th>발송일</th>
                  <th>대상자</th>
                  <th>발송자</th>
                  <th>파일</th>
                  <th>수신 상태</th>
                </tr>
              </thead>
              <tbody>
                <tr className="selected">
                  <td><input type='checkbox' id='chk01' className="com_chk"/><label/></td>
                  <td>2022, 08, 25 18:30</td>
                  <td><button className="btn_link">김교사103</button></td>
                  <td><button className="btn_link">김승인103</button></td>
                  <td><button className="btn_link">다운로드</button></td>
                  <td className="td_point">확인완료<br/>2023, 05, 10  11:30</td>
                </tr>
                <tr>
                  <td><input type='checkbox' id='chk01' className="com_chk"/><label/></td>
                  <td>2022, 08, 25 18:30</td>
                  <td><button className="btn_link">김교사103</button></td>
                  <td><button className="btn_link">김승인103</button></td>
                  <td><button className="btn_link">다운로드</button></td>
                  <td className="td_red">미확인</td>
                </tr>
              </tbody>
            </table>
            <div className="com_btn_wrap center">
              <button className="com_btn gray m has_sub">선택한 목록 발송 취소<br/><span className="sub">(미확인 된 메일만 발송 취소 할 수 있습니다.)</span></button>
              <button className="com_btn orange m">선택한 인원 발송 목록으로 이동</button>
            </div>
          </section>
          {/* 상세보기 */}
          <section className="box sec_detail">
            <div className="detail_tit dot">메일 발송 상세내용</div>
            <div className="com_info">
              <p className="name">홍길동104</p>
              <span className="dot" />
              <p className="date">2023.05.20 11:30</p>
              <button className="btn_edit"/>
            </div>
           <ul className="com_input_sec">
            <li className="tit_field">금여 명세서 발송 목록 (13)</li>
            <li className="input_field">
              <div className="send_list">
                <button className="item">김교사 103<span className="btn_del_file"></span></button>
                <button className="item">김교사 103<span className="btn_del_file"></span></button>
                <button className="item">김교사 103<span className="btn_del_file"></span></button>
                <button className="item">김교사 103<span className="btn_del_file"></span></button>
                <button className="item">김교사 103<span className="btn_del_file"></span></button>
                <button className="item">김교사 103<span className="btn_del_file"></span></button>
                <button className="item">김교사 103<span className="btn_del_file"></span></button>
              </div>
            </li>
            <li className="input_field">
              <input type='text'/>
            </li>
            <li className="input_field">
              <textarea/>
            </li>
           </ul>
            <div className="com_btn_wrap center bottom">
              <div className="com_btn orange s">급여 명세서 메일 발송하기</div>
            </div>
          </section>
        </div>
      </div>
   </main>
  );
}

export default SendPaystub;
